<template>
<v-row class="mt-0">
  <v-col cols="12">
    <v-text-field :value="item.id" label="ID" outlined dense hide-details="auto"></v-text-field>
  </v-col>

  <v-col cols="12" md="6">
    <v-text-field :value="item.phoneNumber" label="SDT" outlined dense hide-details="auto"></v-text-field>
  </v-col>
  <v-col cols="12" md="6">
    <v-text-field :value="item.userName" label="User" outlined dense hide-details="auto"></v-text-field>
  </v-col>
  
  <v-col cols="12" md="4">
    <v-text-field :value="item.checkInIp" label="Check-in IP" outlined dense hide-details="auto"></v-text-field>
  </v-col>
  
  <v-col cols="12" md="4">
    <v-text-field :value="item.checkInPlace" label="Check-in Place" outlined dense hide-details="auto" persistent-placeholder></v-text-field>
  </v-col>
  
  <v-col cols="12" md="4">
    <v-text-field :value="$formatter.formatDate(item.checkInTime, 'DD/MM/YYYY hh:mm:ss')" label="Check-in Time" outlined dense hide-details="auto"></v-text-field>
  </v-col>

  <v-col cols="12" md="4">
    <v-text-field :value="item.checkOutIp" label="Check-out IP" outlined dense hide-details="auto" persistent-placeholder placeholder=""></v-text-field>
  </v-col>

  <v-col cols="12" md="4">
    <v-text-field :value="item.checkOutPlace" label="Check-out Place" outlined dense hide-details="auto" persistent-placeholder placeholder=""></v-text-field>
  </v-col>

  <v-col cols="12" md="4">
    <v-text-field :value="item.checkOutTime ? $formatter.formatDate(item.checkOutTime, 'DD/MM/YYYY hh:mm:ss') : ''" label="Check-out Time" outlined dense hide-details="auto" persistent-placeholder placeholder=""></v-text-field>
  </v-col>

  <v-col cols="12" md="4">
    <v-text-field :value="item.checkInAddress" label="Check-in Address" outlined dense hide-details="auto"></v-text-field>
  </v-col>

  <v-col cols="12" md="4">
    <v-text-field :value="item.checkInLong" label="Check-in Longitude" outlined dense hide-details="auto"></v-text-field>
  </v-col>

  <v-col cols="12" md="4">
    <v-text-field :value="item.checkInLat" label="Check-in Latitude" outlined dense hide-details="auto"></v-text-field>
  </v-col>

  <v-col cols="12" md="4">
    <v-text-field :value="item.checkOutAddress" label="Check-out Address" outlined dense hide-details="auto"></v-text-field>
  </v-col>

  <v-col cols="12" md="4">
    <v-text-field :value="item.checkOutLong" label="Check-out Longitude" outlined dense hide-details="auto"></v-text-field>
  </v-col>

  <v-col cols="12" md="4">
    <v-text-field :value="item.checkOutLat" label="Check-out Latitude" outlined dense hide-details="auto"></v-text-field>
  </v-col>

  <v-col cols="12">
    <v-textarea :value="item.review" label="Review" outlined dense hide-details="auto"></v-textarea>
  </v-col>
  
  <v-col cols="12" md="6">
    <v-text-field :value="$formatter.formatDate(item.createdAt, 'DD/MM/YYYY hh:mm:ss')" label="Created At" outlined dense hide-details="auto"></v-text-field>
  </v-col>

</v-row>
</template>

<script>
export default {
  props:['item']
}
</script>